<script>
    // ═══ ВНУТРИСЕРВЕРНЫЕ ОБЪЯВЛЕНИЯ ═══
    // Это то, что видят ВСЕ игроки: сообщения администрации (/global),
    // мероприятия, AirDrop, казино. Геймод шлёт их событием hud.event.
    //
    // Своего блока на экране у объявления больше нет: раньше оно стояло
    // отдельно и налезало на уведомления. Теперь объявление уходит в ОБЩУЮ
    // ленту (блок «Уведомления») — тот же размер и место, но свои золотые
    // цвета и заметно больший срок показа. Здесь остался только контроллер,
    // он ничего не рисует, а кладёт объявление в стор ленты.
    import { hudEditMode } from 'store/hudlayout'
    import { feedAnnounce } from 'store/hudfeed'

    export let visible1 = false;
    export let subTitle1 = '';
    export let title1 = '';
    export let desc1 = '';

    // объявление держится минимум столько, даже если сервер снял его раньше:
    // «главное» сообщение должно успеть прочитаться
    const MIN_MS = 14000;
    const DEMO_MS = 14000;

    const DEMO = {
        kick: 'Администрация',
        head: 'Объявление сервера',
        text: 'Так выглядит объявление, которое видят все игроки на сервере.',
    };

    let shownAt = 0;
    let dropTimer = null;
    let lastKey = '';

    // показ для примерки в редакторе худа
    let demo = false;
    let demoTimer = null;
    window.hudStore.demoAnnounce = () => {
        demo = true;
        if (demoTimer) clearTimeout(demoTimer);
        demoTimer = setTimeout(() => { demo = false; demoTimer = null; }, DEMO_MS);
    };

    const push = (data) => {
        const key = data.kick + '|' + data.head + '|' + data.text;
        if (key === lastKey) return;          // то же самое — не дёргаем ленту
        lastKey = key;
        shownAt = Date.now();
        if (dropTimer) { clearTimeout(dropTimer); dropTimer = null; }
        feedAnnounce.set(data);
    };

    const drop = () => {
        if (!lastKey) return;
        const left = MIN_MS - (Date.now() - shownAt);
        if (left > 0) {
            // сервер снял объявление раньше срока — дадим дочитать
            if (!dropTimer) dropTimer = setTimeout(() => { dropTimer = null; lastKey = ''; feedAnnounce.set(null); }, left);
            return;
        }
        lastKey = '';
        feedAnnounce.set(null);
    };

    // «Предложение» — это отдельная механика (обмен), не объявление
    $: real = visible1 && subTitle1 !== 'Предложение';

    $: {
        if (real) push({ kick: subTitle1 || 'Объявление', head: title1 || '', text: desc1 || '' });
        else if (demo || $hudEditMode) push(DEMO);
        else drop();
    }

    // вышли из редактора — примерочное объявление убираем сразу
    $: if (!$hudEditMode && !demo && !real && lastKey === (DEMO.kick + '|' + DEMO.head + '|' + DEMO.text)) {
        if (dropTimer) { clearTimeout(dropTimer); dropTimer = null; }
        lastKey = '';
        feedAnnounce.set(null);
    }
</script>
